import { render, staticRenderFns } from "./TeamReview.vue?vue&type=template&id=5d23fae4&scoped=true"
import script from "./TeamReview.vue?vue&type=script&lang=js"
export * from "./TeamReview.vue?vue&type=script&lang=js"
import style0 from "./TeamReview.vue?vue&type=style&index=0&id=5d23fae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d23fae4",
  null
  
)

export default component.exports